module.exports = __webpack_public_path__ + "static/media/male-avatar-portrait.e1763972.png";